import React from 'react';

import TextPage from 'Components/TextPage';
import TextPageHeader from 'Components/TextPageHeader';
import text from '../static/text/termsOfService.md';

class TermsOfService extends React.Component {
  render() {
    return (
      <main className="Page__content">
        <TextPageHeader
          title="Terms of Service"
          description={
            <p className="TextPageHeader__paragraph">
              Welcome to Tinybop Schools! We are a website with educational
              interactive models, content, and activities for learning in the
              classroom and at home. Administrators and teachers may register
              their schools, classes, and students for use of Tinybop Schools.
              Parents may access Tinybop Schools with their children who are
              registered as students.
            </p>
          }
        />
        <TextPage html={text} />
      </main>
    );
  }
}

export default TermsOfService;
